import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommonProjectType } from "../../Types/HeyTraderTypes/CommonProjectType";
import { getCommonProjects } from "../../Thunks/HeyTraderThunks";

interface ToolBrandSliceState {
    loader: boolean; // for refres pages and inital loadings
    projectList: CommonProjectType[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : ToolBrandSliceState = {
    loader: false,
    projectList: [],
    errorDisplay: '',

}

// set state valu for api response


const commonProjectSlice = createSlice ({
    name: 'projectList',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getCommonProjects.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getCommonProjects.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getCommonProjects.fulfilled, (state, action: PayloadAction<CommonProjectType[]>) => {
                    state.loader = false;
                    state.projectList = action.payload;
                  })
    }
})

export const {} = commonProjectSlice.actions
export default commonProjectSlice.reducer

